export default __webpack_public_path__ + "static/media/Groww.83a6db8d.png";